import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  emailLabel: {
    id: "more.profileSettings.emailLabel",
    defaultMessage: "Email"
  },
  phoneLabel: {
    id: "more.profileSettings.phoneLabel",
    defaultMessage: "Phone"
  },
  changePassLabel: {
    id: "more.profileSettings.changePassLabel",
    defaultMessage: "Change Password"
  },
  loadingText: {
    id: "more.profileSettings.loadingText",
    defaultMessage: "Loading..."
  },
  saveText: {
    id: "more.profileSettings.saveText",
    defaultMessage: "Save"
  },
  editText: {
    id: "more.profileSettings.editText",
    defaultMessage: "Edit"
  },
  successUpdatedSnackbar: {
    id: "more.profileSettings.successUpdatedSnackbar",
    defaultMessage: "Successfully updated "
  },
  failedUpdateSnackbar: {
    id: "more.profileSettings.failedUpdateSnackbar",
    defaultMessage: "Failed to update your data, please try again later"
  },
  passwordCharsErrorText: {
    id: "more.profileSettings.passwordCharsErrorText",
    defaultMessage: "Password must be at least 6 characters"
  },
  validMailErrorText: {
    id: "more.profileSettings.validMailErrorText",
    defaultMessage: "Please use a valid email"
  },
  acceptButtonText: {
    id: "more.profileSettings.acceptButtonText",
    defaultMessage: "Yes!"
  },
  allowAccessAlertMessage: {
    id: "more.profileSettings.allowAccessAlertMessage",
    defaultMessage: "Allow Coligo LMS to access your media?"
  },
  unableAccessAlertTitle: {
    id: "more.profileSettings.unableAccessAlertTitle",
    defaultMessage: "Unable to access your media!"
  },
  confirmPassLabel: {
    id: "more.profileSettings.confirmPassLabel",
    defaultMessage: "Confirm Password"
  },
  passMatchErrorText: {
    id: "more.profileSettings.passMatchErrorText",
    defaultMessage: "Passwords should match"
  }
});